var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ParseForm',{ref:"bus",attrs:{"formParams":_vm.formParams,"reMountPage":_vm.reMountPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }